import React, { useState } from "react";
import { Wrapper, Container } from "./style";
import Content from "./components/Content";
import Header from "../components/Header";
import { MODAL_EDIT_REJECTION } from "store/Modals/constants";

const EditRejectionModal = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Wrapper>
      <Container expanded={expanded}>
        <Header expanded={expanded} setExpanded={setExpanded} modal={MODAL_EDIT_REJECTION} title={"Motivo del Rechazo"}/>
        <Content expanded={expanded} />
      </Container>
    </Wrapper>
  );
};

export default EditRejectionModal;
